module.exports = __webpack_public_path__ + "img/serifnew_box00.9e77aa17.jpg";